<div *ngIf="content$ | async as appContent">
	<form [formGroup]="childForm" ngxsForm="childState.childForm">
		<div formArrayName="children" class="nha-sa-section">
			<div *ngFor="let child of children.controls; let c = index" [formGroupName]="c">
				<div class="nha-sa-section-header">
					<span *ngIf="child.get('firstName').value.trim() && child.get('lastName').value.trim()">
						{{ child.get('firstName').value + ' ' + child.get('lastName').value | possessive }}
						{{ appContent.resourceStrings['nha.sa.information'] }}
					</span>
					<span *ngIf="!child.get('firstName').value.trim() || !child.get('lastName').value.trim()">
						<span class="child-header">
							{{ appContent.resourceStrings['nha.sa.childsinformationheader'] | placeholder : c + 1 }}
						</span>
						<span class="print-child-header"> Child's Information </span>
					</span>
					<span class="nha-pattern-dots"></span>
				</div>
				<div class="nha-row">
					<div formArrayName="guardianRelationships">
						<div *ngFor="let relationshipInfo of child.controls.guardianRelationships.controls; let r = index" [formGroupName]="r">
							<div class="nha-form-group nha-input-select nha-gr-12 nha-gr-6@sm nha-gr-5@md" [ngClass]="{ 'nha-clear': r % 2 === 0 }">
								<label for="childRelationship{{ c }}-{{ r }}">
									<span class="nha-required" aria-hidden="true">*</span>
									<span class="parent-header">
										{{
											appContent.resourceStrings['nha.sa.guardianrelationship']
												| placeholder : (relationshipInfo.value | fullName : r | possessive)
										}}
									</span>
									<span class="print-parent-header"> Parent/Guardian's Relationship to Child </span>
									<span id="relationshipTooltip{{ c }}" role="tooltip" *ngIf="r === 0" class="nha-tooltip">
										<span class="nha-tooltip-icon"></span>
										<span class="nha-tooltip-content">
											<span class="nha-tooltip-green-bar"></span>
											{{ appContent.resourceStrings['nha.sa.guardianrelationshiptooltip'] }}
										</span>
									</span>
								</label>
								<select
									id="childRelationship{{ c }}-{{ r }}"
									class="nha-form-control"
									formControlName="relationshipTypeId"
									[attr.aria-describedby]="'relationshipTooltip' + c"
									aria-required="true"
								>
									<option></option>
									<option *ngFor="let relationship of appContent.relationshipTypes" value="{{ relationship.relationshipTypeID }}">
										{{ relationship.relationshipTypeName }}
									</option>
								</select>
								<div
									*ngIf="
										getArrayControl(c, 'guardianRelationships', r, 'relationshipTypeId').invalid &&
										(getArrayControl(c, 'guardianRelationships', r, 'relationshipTypeId').dirty ||
											getArrayControl(c, 'guardianRelationships', r, 'relationshipTypeId').touched)
									"
									class="nha-form-error-desc"
								>
									<span *ngIf="getArrayControl(c, 'guardianRelationships', r, 'relationshipTypeId').errors.required">{{
										appContent.resourceStrings['nha.sa.errorguardianrelationship']
									}}</span>
									<span *ngIf="getArrayControl(c, 'guardianRelationships', r, 'relationshipTypeId').errors.unsafeValue">{{
										appContent.resourceStrings['nha.sa.errorinvalidcharacter']
									}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="nha-row print-row">
					<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
						<label for="childFirstName{{ c }}"
							><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.childsfirstname'] }}</label
						>
						<input id="childFirstName{{ c }}" class="nha-form-control" type="text" formControlName="firstName" aria-required="true"/>
						<div
							*ngIf="getControl(c, 'firstName').invalid && (getControl(c, 'firstName').dirty || getControl(c, 'firstName').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(c, 'firstName').errors.required">{{ appContent.resourceStrings['nha.sa.errorfirstname'] }}</span>
							<span *ngIf="getControl(c, 'firstName').errors.maxlength">{{ appContent.resourceStrings['nha.sa.errorlongvalue'] }}</span>
							<span *ngIf="getControl(c, 'firstName').errors.unsafeValue">{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}</span>
						</div>
					</div>
					<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
						<label for="childMiddleName{{ c }}">{{ appContent.resourceStrings['nha.sa.childsmiddlename'] }}</label>
						<input id="childMiddleName{{ c }}" class="nha-form-control" type="text" formControlName="middleName" />
						<div
							*ngIf="getControl(c, 'middleName').invalid && (getControl(c, 'middleName').dirty || getControl(c, 'middleName').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(c, 'middleName').errors.maxlength">{{ appContent.resourceStrings['nha.sa.errorlongvalue'] }}</span>
							<span *ngIf="getControl(c, 'middleName').errors.unsafeValue">{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}</span>
						</div>
					</div>
				</div>
				<div class="nha-row print-row">
					<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
						<label for="childLastName{{ c }}"><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.childslastname'] }}</label>
						<input id="childLastName{{ c }}" class="nha-form-control" type="text" formControlName="lastName" aria-required="true"/>
						<div
							*ngIf="getControl(c, 'lastName').invalid && (getControl(c, 'lastName').dirty || getControl(c, 'lastName').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(c, 'lastName').errors.required">{{ appContent.resourceStrings['nha.sa.errorlastname'] }}</span>
							<span *ngIf="getControl(c, 'lastName').errors.maxlength">{{ appContent.resourceStrings['nha.sa.errorlongvalue'] }}</span>
							<span *ngIf="getControl(c, 'lastName').errors.unsafeValue">{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}</span>
						</div>
					</div>
					<div class="nha-form-group nha-input-select nha-gr-6 nha-gr-4@sm nha-gr-3@md">
						<label for="childSuffixId{{ c }}">
							{{ appContent.resourceStrings['nha.sa.childssuffix'] }}
							<span role="tooltip" id="childSuffixTooltip{{ c }}" class="nha-tooltip">
								<span class="nha-tooltip-icon"></span>
								<span class="nha-tooltip-content">
									<span class="nha-tooltip-green-bar"></span>
									{{ appContent.resourceStrings['nha.sa.childssuffixtooltip'] }}
								</span>
							</span>
						</label>
						<select
							id="childSuffixId{{ c }}"
							class="nha-form-control"
							formControlName="suffixId"
							[attr.aria-describedby]="'childSuffixTooltip' + c"
						>
							<option></option>
							<option *ngFor="let nameSuffix of appContent.nameSuffixes" value="{{ nameSuffix.nameSuffixID }}">
								{{ nameSuffix.suffix }}
							</option>
						</select>
						<div
							*ngIf="getControl(c, 'suffixId').invalid && (getControl(c, 'suffixId').dirty || getControl(c, 'suffixId').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(c, 'suffixId').errors.unsafeValue">{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}</span>
						</div>
					</div>
				</div>
				<div class="nha-row print-row">
					<div class="nha-form-group nha-input-select nha-gr-12 nha-gr-6@sm nha-gr-5@md">
						<label for="childBirthMonth{{ c }}">
							<span class="nha-required" aria-hidden="true">*</span>
							{{ appContent.resourceStrings['nha.sa.childsbirthdate'] }}
						</label>
						<select
							id="childBirthMonth{{ c }}"
							class="nha-form-control"
							formControlName="birthMonth"
							(change)="validateGradeLevelControlsForChild(c)"
							aria-required="true"
						>
							<option value="">
								{{ appContent.resourceStrings['nha.sa.month'] }}
							</option>
							<option value="01">
								{{ appContent.resourceStrings['nha.sa.january'] }}
							</option>
							<option value="02">
								{{ appContent.resourceStrings['nha.sa.february'] }}
							</option>
							<option value="03">
								{{ appContent.resourceStrings['nha.sa.march'] }}
							</option>
							<option value="04">
								{{ appContent.resourceStrings['nha.sa.april'] }}
							</option>
							<option value="05">
								{{ appContent.resourceStrings['nha.sa.may'] }}
							</option>
							<option value="06">
								{{ appContent.resourceStrings['nha.sa.june'] }}
							</option>
							<option value="07">
								{{ appContent.resourceStrings['nha.sa.july'] }}
							</option>
							<option value="08">
								{{ appContent.resourceStrings['nha.sa.august'] }}
							</option>
							<option value="09">
								{{ appContent.resourceStrings['nha.sa.september'] }}
							</option>
							<option value="10">
								{{ appContent.resourceStrings['nha.sa.october'] }}
							</option>
							<option value="11">
								{{ appContent.resourceStrings['nha.sa.november'] }}
							</option>
							<option value="12">
								{{ appContent.resourceStrings['nha.sa.december'] }}
							</option>
						</select>
						<div
							*ngIf="getControl(c, 'birthMonth').invalid && (getControl(c, 'birthMonth').dirty || getControl(c, 'birthMonth').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(c, 'birthMonth').errors.required">{{ appContent.resourceStrings['nha.sa.errormonthisrequired'] }}</span>
							<span *ngIf="getControl(c, 'birthMonth').errors.unsafeValue">{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}</span>
						</div>
					</div>
					<div class="nha-form-group nha-gr-5 nha-gr-2@sm nha-gr-2@md birthdate">
						<label for="childBirthDay{{ c }}" class="nha-hide">{{ appContent.resourceStrings['nha.sa.childsbirthdatedayfieldtext'] }}</label>
						<input
							id="childBirthDay{{ c }}"
							class="nha-form-control"
							type="text"
							formControlName="birthDay"
							appNumberLimitTo="2"
							placeholder="{{ appContent.resourceStrings['nha.sa.childsbirthdatedayfieldtext'] }}"
							(change)="validateGradeLevelControlsForChild(c)"
							aria-required="true"
						/>
						<div
							*ngIf="getControl(c, 'birthDay').invalid && (getControl(c, 'birthDay').dirty || getControl(c, 'birthDay').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(c, 'birthDay').errors.required">{{ appContent.resourceStrings['nha.sa.errorchildsbirthdateday'] }}</span>
							<span *ngIf="getControl(c, 'birthDay').errors.max">{{ appContent.resourceStrings['nha.sa.errordaytoohigh'] }}</span>
							<span *ngIf="getControl(c, 'birthDay').errors.min">{{ appContent.resourceStrings['nha.sa.errordaytoolow'] }}</span>
							<span *ngIf="getControl(c, 'birthDay').errors.unsafeValue">{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}</span>
						</div>
					</div>
					<div class="nha-form-group nha-gr-7 nha-gr-4@sm nha-gr-3@md birthdate">
						<label for="childBirthYear{{ c }}" class="nha-hide">{{ appContent.resourceStrings['nha.sa.childsbirthdateyearfieldtext'] }}</label>
						<input
							id="childBirthYear{{ c }}"
							class="nha-form-control"
							type="text"
							formControlName="birthYear"
							appNumberLimitTo="4"
							placeholder="{{ appContent.resourceStrings['nha.sa.childsbirthdateyearfieldtext'] }}"
							(change)="validateGradeLevelControlsForChild(c)"
							aria-required="true"
						/>
						<div
							*ngIf="getControl(c, 'birthYear').invalid && (getControl(c, 'birthYear').dirty || getControl(c, 'birthYear').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(c, 'birthYear').errors.required">{{ appContent.resourceStrings['nha.sa.errorchildsbirthdateyear'] }}</span>
							<span *ngIf="getControl(c, 'birthYear').errors.max">{{ appContent.resourceStrings['nha.sa.errorhighyear'] }}</span>
							<span *ngIf="getControl(c, 'birthYear').errors.min">{{ appContent.resourceStrings['nha.sa.errorlowyear'] }}</span>
							<span *ngIf="getControl(c, 'birthYear').errors.unsafeValue">{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}</span>
						</div>
					</div>
				</div>
				<div *ngIf="childGroup(c).touched && childGroup(c).hasError('invalidBirthDate')" class="nha-row nha-invalid-birthdate ng-touched ng-invalid">
					<div class="nha-gr-12 nha-gr-10@md">
						<div class="nha-form-group-error">
							{{ appContent.resourceStrings['nha.sa.errorinvalidbirthdate'] }}
						</div>
					</div>
				</div>
				<div *ngIf="getControl(c, 'displayKindergartenWaiver').value" class="nha-row">
					<div class="nha-gr-12">
						<div class="nha-form-group nha-inline-block nha-form-single-check">
							<input
								id="kindergartenWaiverCheckbox{{ c }}"
								class="nha-input-checkbox"
								type="checkbox"
								value="false"
								formControlName="isKindergartenWaiverApproved"
							/>
							<label for="kindergartenWaiverCheckbox{{ c }}"
								><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.kindergartenwaiver'] }}</label
							>
							<div class="nha-form-error-desc">
								{{ appContent.resourceStrings['nha.sa.errorfieldrequired'] }}
							</div>
						</div>
					</div>
				</div>
				<div *ngIf="appContent.stateCode != 'NC' && appContent.stateCode != 'NY'" class="nha-row">
					<div class="nha-form-group nha-input-select nha-gr-12 nha-gr-6@sm nha-gr-5@md">
						<label for="childGender{{ c }}"><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.childsgender'] }}</label>
						<select id="childGender{{ c }}" class="nha-form-control" formControlName="genderId">
							<option></option>
							<option value="1">
								{{ appContent.resourceStrings['nha.sa.childsgendermale'] }}
							</option>
							<option value="2">
								{{ appContent.resourceStrings['nha.sa.childsgenderfemale'] }}
							</option>
						</select>
						<div
							*ngIf="getControl(c, 'genderId').invalid && (getControl(c, 'genderId').dirty || getControl(c, 'genderId').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(c, 'genderId').errors.required">{{ appContent.resourceStrings['nha.sa.errorchildsgender'] }}</span>
							<span *ngIf="getControl(c, 'genderId').errors.unsafeValue">{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}</span>
						</div>
					</div>
				</div>
				<hr />
				<div class="nha-row nha-clear">
					<div formArrayName="householdResidencies" class="nha-sa-residency-container">
						<div *ngIf="getArray(c, 'householdResidencies').dirty && getArray(c, 'householdResidencies').errors" class="nha-row">
							<div class="nha-gr-12 nha-gr-10@md">
								<div class="nha-form-group-error">
									<span *ngIf="getArray(c, 'householdResidencies').hasError('fullTimeError')">{{
										appContent.resourceStrings['nha.sa.errorfulltime']
									}}</span>
									<span *ngIf="getArray(c, 'householdResidencies').hasError('noResidencyError')">{{
										appContent.resourceStrings['nha.sa.errorresidency']
									}}</span>
								</div>
							</div>
						</div>
						<div *ngFor="let residencyInfo of child.controls.householdResidencies.controls; let h = index" [formGroupName]="h">
							<legend id="childResidencyQuestion{{ c }}-{{ h }}" class="nha-gr-12" [attr.aria-describedby]="'childResidencyTooltip' + c">
								<span class="nha-required" aria-hidden="true" *ngIf="!schoolIsNY || h > 0">*</span>
								{{
									appContent.resourceStrings['nha.sa.childsresidencequestion']
										| placeholder : (residencyInfo.value | addressOrName)
										| placeholder2 : appContent.resourceStrings['nha.sa.address']
								}}
								<span role="tooltip" *ngIf="h == 0" id="childResidencyTooltip{{ c }}" class="nha-tooltip">
									<span class="nha-tooltip-icon"></span>
									<span class="nha-tooltip-content">
										<span class="nha-tooltip-green-bar"></span>
										{{ appContent.resourceStrings['nha.sa.childsresidencetooltip'] }}
									</span>
								</span>
							</legend>
							<fieldset class="nha-form-radio print-row" tabindex="0">
								<div *ngFor="let residencyType of appContent.residencyTypes; let resIdx = index" class="nha-gr-12">
									<div class="nha-form-group nha-inline-block">
										<input
											id="childResidency{{ residencyType.residencyTypeID }}-{{ c }}-{{ h }}"
											class="nha-input-radio"
											type="radio"
											formControlName="residencyTypeId"
											value="{{ residencyType.residencyTypeID }}"
											[attr.aria-labelledby]="
												'childResidencyQuestion' + c + '-' + h + ' childResidency' + residencyType.residencyTypeID + '-' + c + '-' + h
											"
										/>
										<label for="childResidency{{ residencyType.residencyTypeID }}-{{ c }}-{{ h }}">{{
											residencyType.residencyTypeName
										}}</label>
										<div
											*ngIf="
												resIdx == 0 &&
												getArrayControl(c, 'householdResidencies', h, 'residencyTypeId').invalid &&
												(getArrayControl(c, 'householdResidencies', h, 'residencyTypeId').dirty ||
													getArrayControl(c, 'householdResidencies', h, 'residencyTypeId').touched)
											"
											class="nha-form-error-desc"
										>
											<span *ngIf="getArrayControl(c, 'householdResidencies', h, 'residencyTypeId').errors.required">{{
												appContent.resourceStrings['nha.sa.errorchildsresidencequestion']
											}}</span>
											<span *ngIf="getArrayControl(c, 'householdResidencies', h, 'residencyTypeId').errors.unsafeValue">{{
												appContent.resourceStrings['nha.sa.errorinvalidcharacter']
											}}</span>
										</div>
									</div>
								</div>
							</fieldset>
							<hr />
						</div>
					</div>
				</div>
				<div *ngIf="appContent.languages && appContent.languages.length > 0 && academicYearApplying > 2019" class="nha-row">
					<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
						<label for="preferredLanguage{{ c }}">
							{{ appContent.resourceStrings['nha.sa.childspreferredlanguagequestion'] }}
							<span role="tooltip" class="nha-tooltip">
								<span class="nha-tooltip-icon"></span>
								<span class="nha-tooltip-content">
									<span class="nha-tooltip-green-bar"></span>
									{{ appContent.resourceStrings['nha.sa.childspreferredlanguagetooltip'] }}
								</span>
							</span>
						</label>
						<div class="nha-autocomplete" [attr.data-source]="getLanguageList()">
							<input id="preferredLanguage{{ c }}" class="nha-form-control" formControlName="preferredLanguage" type="text" />
							<div
								*ngIf="
									getControl(c, 'preferredLanguage').invalid &&
									(getControl(c, 'preferredLanguage').dirty || getControl(c, 'preferredLanguage').touched)
								"
								class="nha-form-error-desc"
							>
								<span *ngIf="getControl(c, 'preferredLanguage').errors.invalidLanguage">{{
									appContent.resourceStrings['nha.sa.errorinvalidlanguage']
								}}</span>
							</div>
						</div>
					</div>
					<hr />
				</div>
				<!-- Lottery Questions -->
				<div class="nha-row">
					<fieldset class="nha-form-radio" *ngIf="showELLQuestion" tabindex="0">
						<legend id="englishLanguageLearnerQuestion{{ c }}" class="nha-gr-12" [attr.aria-describedby]="'ELLTooltip' + c">
							{{ appContent.resourceStrings['nha.sa.capstoneell'] }}
							<span role="tooltip" *ngIf="appContent.englishLanguageLearnerQuestionTooltip" id="ELLTooltip{{ c }}" class="nha-tooltip">
								<span class="nha-tooltip-icon"></span>
								<span class="nha-tooltip-content">
									<span class="nha-tooltip-green-bar"></span>
									{{ appContent.englishLanguageLearnerQuestionTooltip }}
								</span>
							</span>
						</legend>
						<div class="nha-gr-12">
							<div class="nha-form-group nha-inline-block">
								<input
									id="englishLanguageLearnerYes{{ c }}"
									formControlName="isEnglishLanguageLearner"
									[value]="true"
									[attr.aria-labelledby]="'englishLanguageLearnerQuestion' + c + ' englishLanguageLearnerYes' + c"
									class="nha-input-radio"
									type="radio"
								/>
								<label for="englishLanguageLearnerYes{{ c }}">{{ appContent.resourceStrings['nha.sa.yes'] }}</label>
							</div>
						</div>
						<div class="nha-gr-12">
							<div class="nha-form-group nha-inline-block">
								<input
									id="englishLanguageLearnerNo{{ c }}"
									formControlName="isEnglishLanguageLearner"
									[value]="false"
									[attr.aria-labelledby]="'englishLanguageLearnerQuestion' + c + ' englishLanguageLearnerNo' + c"
									class="nha-input-radio"
									type="radio"
								/>
								<label for="englishLanguageLearnerNo{{ c }}">No</label>
							</div>
						</div>
					</fieldset>
					<fieldset class="nha-form-radio" *ngIf="showFRLQuestion" tabindex="0">
						<legend id="freeReducedLunchQuestion{{ c }}" class="nha-gr-12" [attr.aria-describedby]="'FRLTooltip' + c">
							{{ appContent.resourceStrings['nha.sa.capstonefrl'] }}
							<span role="tooltip" *ngIf="appContent.freeReducedLunchQuestionTooltip" id="FRLTooltip{{ c }}" class="nha-tooltip">
								<span class="nha-tooltip-icon"></span>
								<span class="nha-tooltip-content">
									<span class="nha-tooltip-green-bar"></span>
									{{ appContent.freeReducedLunchQuestionTooltip }}
								</span>
							</span>
						</legend>
						<div class="print-row">
							<div class="nha-gr-12">
								<div class="nha-form-group nha-inline-block">
									<input
										id="freeReducedLunchYes{{ c }}"
										formControlName="isEligibleForFreeAndReducedLunch"
										[value]="true"
										[attr.aria-labelledby]="'freeReducedLunchQuestion' + c + ' freeReducedLunchYes' + c"
										class="nha-input-radio"
										type="radio"
									/>
									<label for="freeReducedLunchYes{{ c }}">{{ appContent.resourceStrings['nha.sa.yes'] }}</label>
								</div>
							</div>
							<div class="nha-gr-12">
								<div class="nha-form-group nha-inline-block">
									<input
										id="freeReducedLunchNo{{ c }}"
										formControlName="isEligibleForFreeAndReducedLunch"
										[value]="false"
										[attr.aria-labelledby]="'freeReducedLunchQuestion' + c + ' freeReducedLunchNo' + c"
										class="nha-input-radio"
										type="radio"
									/>
									<label for="freeReducedLunchNo{{ c }}">No</label>
								</div>
							</div>
						</div>
					</fieldset>
					<fieldset class="nha-form-radio print-row" *ngIf="showSPEDQuestion" tabindex="0">
						<legend id="specialEducationQuestion{{ c }}" class="nha-gr-12" [attr.aria-describedby]="'SETooltip' + c">
							{{ appContent.resourceStrings['nha.sa.capstonesped'] }}
							<span role="tooltip" *ngIf="appContent.specialEducationQuestionTooltip" id="SETooltip{{ c }}" class="nha-tooltip">
								<span class="nha-tooltip-icon"></span>
								<span class="nha-tooltip-content">
									<span class="nha-tooltip-green-bar"></span>
									{{ appContent.specialEducationQuestionTooltip }}
								</span>
							</span>
						</legend>
						<div class="nha-gr-12">
							<div class="nha-form-group nha-inline-block">
								<input
									id="specialEducationYes{{ c }}"
									formControlName="isSpecialEducation"
									[value]="true"
									[attr.aria-labelledby]="'specialEducationQuestion' + c + ' specialEducationYes' + c"
									class="nha-input-radio"
									type="radio"
								/>
								<label for="specialEducationYes{{ c }}">{{ appContent.resourceStrings['nha.sa.yes'] }}</label>
							</div>
						</div>
						<div class="nha-gr-12">
							<div class="nha-form-group nha-inline-block">
								<input
									id="specialEducationNo{{ c }}"
									formControlName="isSpecialEducation"
									[value]="false"
									[attr.aria-labelledby]="'specialEducationQuestion' + c + ' specialEducationNo' + c"
									class="nha-input-radio"
									type="radio"
								/>
								<label for="specialEducationNo{{ c }}">No</label>
							</div>
						</div>
					</fieldset>
					<hr
						*ngIf="
							appContent?.showEnglishLanguageLearnerQuestion ||
							appContent?.showFreeReducedLunchQuestion ||
							appContent?.showSpecialEducationQuestion
						"
					/>
				</div>
				<!-- Matriculation Questions -->
				<div
					class="nha-row"
					*ngIf="
						academicYearApplying === appContent.currentAcademicYear ? appContent.currentMatriculatingSchools : appContent.nextMatriculatingSchools
					"
				>
					<fieldset>
						<legend id="matriculatingSchool{{ c }}" class="nha-gr-12" [attr.aria-describedby]="'matriculatingSchool' + c">
							{{ appContent.resourceStrings['nha.sa.matriculationquestion'] }}
						</legend>
						<div class="nha-gr-12 print-row">
							<div
								class="nha-form-group"
								*ngFor="
									let school of academicYearApplying === appContent.currentAcademicYear
										? appContent.currentMatriculatingSchools
										: appContent.nextMatriculatingSchools;
									let s = index
								"
							>
								<input
									id="matriculatingSchool-{{ c }}-{{ school.schoolID }}"
									class="nha-input-radio"
									type="checkbox"
									(change)="mapMatriculationSchools(c, school.schoolID, $event?.target?.checked)"
								/>
								<label for="matriculatingSchool-{{ c }}-{{ school.schoolID }}">{{ school.schoolName }}</label>
							</div>
						</div>
					</fieldset>
					<hr />
				</div>

				<!-- PVA self-Paced -->
				@if(appContent.schoolID === 509 && academicYearApplying > 2024) {
					<fieldset class="display-flex" tabindex="0">
						<label for="pvaLiveOnline-{{ c }}">
							<span class="nha-required" aria-hidden="true">*</span>
							Learning Model
						</label>
						<div class="nha-form-group nha-inline-block">
							<input
								id="pvaLiveOnline-{{ c }}"
								type="radio"
								class="nha-input-radio"
								formControlName="isSelfPaced"
								[value]="false"
								aria-labelledby="pvaQuestion pvaLiveOnlineLabel"
							/>
							<label id="pvaLiveOnlineLabel-{{ c }}" for="pvaLiveOnline-{{ c }}">
								<span style="font-weight: bold;">PVA Live Online</span>
								(Real-time, live, teacher-led instruction with a structured bell schedule, including established start/end times, break/lunch times, and class times.)
							</label>
						</div>

						<div class="nha-form-group nha-inline-block">
							<input
								id="pvaSelfPaced-{{ c }}"
								type="radio"
								class="nha-input-radio"
								formControlName="isSelfPaced"
								[value]="true"
								aria-labelledby="pvaQuestion pvaSelfPacedLabel"
							/>
							<label id="pvaSelfPacedLabel-{{ c }}" for="pvaSelfPaced-{{ c }}">
								<span style="font-weight: bold;">PVA Self-Paced</span>
								(Independent, self-paced study offering a flexible schedule with teacher support available.)
							</label>
						</div>
						<div
							*ngIf="getControl(c, 'isSelfPaced').invalid && (getControl(c, 'isSelfPaced').dirty || getControl(c, 'isSelfPaced').touched)"
							class="nha-form-group-error"
						>
							<span>Please select a PVA learning option.</span>
						</div>
					</fieldset>

				}

				<!-- Grade Level-->
				<div *ngIf="academicYearApplying === appContent.currentAcademicYear" class="nha-row">
					<div class="nha-form-group nha-input-select nha-gr-12 nha-gr-6@sm nha-suffix-6@sm nha-gr-5@md nha-suffix-7@md">
						<label for="childGradeLevel{{ c }}">
							<strong *ngIf="appContent.schoolID === 497 || appContent.schoolID === 508">
								Westfield Charter Academy (K-6)<br />
								Westfield Prep (7-{{ appContent.currentGradeLevels[appContent.currentGradeLevels.length - 1].gradeLevelName }})<br />
							</strong>
							<strong *ngIf="appContent.schoolID !== 497 && appContent.schoolID !== 508"> {{ appContent.schoolName }}<br /> </strong>
							<span class="nha-required" aria-hidden="true">*</span>
							{{ appContent.resourceStrings['nha.sa.gradeentering'] }}
							{{ appContent.currentAcademicYear }}-{{ appContent.currentAcademicYear + 1 }} ({{
								appContent.resourceStrings['nha.sa.currentschoolyear']
							}})
						</label>
						<select
							id="childGradeLevel{{ c }}"
							class="nha-form-control"
							formControlName="gradeLevelId"
							(change)="validateGradeLevelControlsForChild(c)"
							aria-required="true"
						>
							<option></option>
							<option *ngFor="let gradeLevel of appContent.currentGradeLevels" [ngValue]="gradeLevel.gradeLevelID">
								{{ gradeLevel.description }}
							</option>
						</select>
						<div
							*ngIf="getControl(c, 'gradeLevelId').invalid && (getControl(c, 'gradeLevelId').dirty || getControl(c, 'gradeLevelId').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(c, 'gradeLevelId').errors.required">{{
								appContent.resourceStrings['nha.sa.errorchildsgradeentering']
							}}</span>
							<span *ngIf="getControl(c, 'gradeLevelId').errors.tooYoungToApply">{{
								appContent.resourceStrings['nha.sa.erroradditionalschoolsgrade']
							}}</span>
							<span *ngIf="getControl(c, 'gradeLevelId').errors.unsafeValue">{{
								appContent.resourceStrings['nha.sa.errorinvalidcharacter']
							}}</span>
						</div>
					</div>
				</div>
				<div *ngIf="academicYearApplying === appContent.nextAcademicYear" class="nha-row">
					<div class="nha-form-group nha-input-select nha-gr-12 nha-gr-6@sm nha-suffix-6@sm nha-gr-5@md nha-suffix-7@md">
						<label for="childGradeLevel{{ c }}">
							<strong *ngIf="appContent.schoolID === 497 || appContent.schoolID === 508">
								Westfield Charter Academy (K-6)<br />
								Westfield Prep (7-{{ appContent.nextGradeLevels[appContent.nextGradeLevels.length - 1].gradeLevelName }})<br />
							</strong>
							<strong *ngIf="appContent.schoolID !== 497 && appContent.schoolID !== 508"> {{ appContent.schoolName }}<br /> </strong>
							<span class="nha-required" aria-hidden="true">*</span>
							{{ appContent.resourceStrings['nha.sa.gradeentering'] }}
							{{ appContent.nextAcademicYear }}-{{ appContent.nextAcademicYear + 1 }} ({{ appContent.resourceStrings['nha.sa.nextschoolyear'] }})
						</label>
						<select
							id="childGradeLevel{{ c }}"
							class="nha-form-control"
							formControlName="gradeLevelId"
							(change)="validateGradeLevelControlsForChild(c)"
							aria-required="true"
						>
							<option></option>
							<option *ngFor="let gradeLevel of appContent.nextGradeLevels" [ngValue]="gradeLevel.gradeLevelID">
								{{ gradeLevel.description }}
							</option>
						</select>
						<div
							*ngIf="getControl(c, 'gradeLevelId').invalid && (getControl(c, 'gradeLevelId').dirty || getControl(c, 'gradeLevelId').touched)"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(c, 'gradeLevelId').errors.required">{{
								appContent.resourceStrings['nha.sa.errorchildsgradeentering']
							}}</span>
							<span *ngIf="getControl(c, 'gradeLevelId').errors.tooYoungToApply">{{
								appContent.resourceStrings['nha.sa.erroradditionalschoolsgrade']
							}}</span>
							<span *ngIf="getControl(c, 'gradeLevelId').errors.unsafeValue">{{
								appContent.resourceStrings['nha.sa.errorinvalidcharacter']
							}}</span>
						</div>
					</div>
				</div>

				<div
					*ngIf="
						(child.get('gradeLevelId').value === '8' ||
							child.get('gradeLevelId').value === '9' ||
							child.get('gradeLevelId').value === '10' ||
							child.get('gradeLevelId').value === '11' ||
							child.get('gradeLevelId').value === '12' ||
							child.get('gradeLevelId').value === '13') &&
						(appContent.schoolID === 497 || appContent.schoolID === 508)
					"
					class="nha-row"
				>
					<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
						<label for="childPreviousSchool{{ c }}">{{ appContent.resourceStrings['nha.sa.previousschool'] }}</label>
						<input id="childPreviousSchool{{ c }}" class="nha-form-control" type="text" formControlName="previousSchool" />
						<div
							*ngIf="
								getControl(c, 'previousSchool').invalid && (getControl(c, 'previousSchool').dirty || getControl(c, 'previousSchool').touched)
							"
							class="nha-form-error-desc"
						>
							<span *ngIf="getControl(c, 'previousSchool').errors.unsafeValue">
								{{ appContent.resourceStrings['nha.sa.errorinvalidcharacter'] }}
							</span>
						</div>
					</div>
				</div>
				<div *ngIf="showReceivedSpecialEd()" class="nha-row" style="margin-top: 20px">
					<fieldset class="nha-form-radio" tabindex="0">
						<legend id="childReceivedSpecidalEdQuestion{{ c }}" class="nha-gr-12" [attr.aria-describedby]="'childReceivedSpecidalEdTooltip' + c">
							{{ appContent.resourceStrings['nha.sa.childreceivedspecialed'] }}
							<span id="childReceivedSpecidalEdTooltip{{ c }}" role="tooltip" class="nha-tooltip" tabindex="0">
								<span class="nha-tooltip-icon"></span>
								<span class="nha-tooltip-content">
									<span class="nha-tooltip-green-bar"></span>
									{{ appContent.resourceStrings['nha.sa.childreceivedspecialedtooltip'] }}
								</span>
							</span>
						</legend>
					</fieldset>
					<div class="print-row">
						<div class="nha-gr-12">
							<div class="nha-form-group nha-inline-block">
								<input
									id="childReceivedSpecidalEdYes{{ c }}"
									formControlName="receivedSpecialEducationServices"
									[value]="true"
									[attr.aria-labelledby]="'childReceivedSpecidalEdQuestion' + c + ' childReceivedSpecidalEdYes' + c"
									class="nha-input-radio"
									type="radio"
								/>
								<label for="childReceivedSpecidalEdYes{{ c }}">{{ appContent.resourceStrings['nha.sa.yes'] }}</label>
							</div>
						</div>
						<div class="nha-gr-12">
							<div class="nha-form-group nha-inline-block">
								<input
									id="childReceivedSpecidalEdNo{{ c }}"
									formControlName="receivedSpecialEducationServices"
									[value]="false"
									[attr.aria-labelledby]="'childReceivedSpecidalEdQuestion' + c + ' childReceivedSpecidalEdNo' + c"
									class="nha-input-radio"
									type="radio"
								/>
								<label for="childReceivedSpecidalEdNo{{ c }}">No</label>
							</div>
						</div>
						<div class="nha-gr-12">
							<div class="nha-form-group nha-inline-block">
								<input
									id="childReceivedSpecidalEdNull{{ c }}"
									formControlName="receivedSpecialEducationServices"
									[value]="null"
									[attr.aria-labelledby]="'childReceivedSpecidalEdQuestion' + c + ' childReceivedSpecidalEdNull' + c"
									class="nha-input-radio"
									type="radio"
								/>
								<label for="childReceivedSpecidalEdNull{{ c }}">{{ appContent.resourceStrings['nha.sa.noanswer'] }}</label>
							</div>
						</div>
					</div>
				</div>
				<div *ngIf="c > 0" class="nha-row">
					<div class="nha-gr-12">
						<a (click)="removeChild(c)" class="nha-warning-link" tabindex="0" (keyup.enter)="removeChild(c)">
							<span class="fa fa-trash-o" aria-hidden="true"></span>
							{{ appContent.resourceStrings['nha.sa.removechild'] }}
						</a>
					</div>
				</div>
			</div>
			<button *ngIf="children.controls.length < 20" type="button" (click)="addChild()" class="nha-btn nha-btn-primary add-another-child">
				{{ appContent.resourceStrings['nha.sa.addanotherchildbutton'] }}
			</button>
		</div>
	</form>
</div>
